import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import { Api, Toast } from './../../../services'

export default {
  name: 'EditProfile',
  props: [],
  components: {
    Header,
    ProgressHUD,
    Footer,
  },
  data() {
    return {
      userData: null,
      validationMessage: '',
      newAvatarImmage: null,
    }
  },
  computed: {
    isWalletAddressETH() {
      // check if walletAddress is empty
      if (this.userData.walletAddress === '') return true // walletAddressETH is required
      return false
    },
    isWalletAddressBTH() {
      // check if walletAddressETH is empty
      if (this.userData.walletAddressETH === '') return true // walletAddress is required
      return false
    },
  },
  methods: {
    async save() {
      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          Toast.validationFieldsError({ toast: this.$toast })

          return
        }

        this.$refs.progress.show()

        await Api.updateProfile({
          fullName: this.userData.fullName,
          phone: this.userData.phone,
          image: this.newAvatarImmage,
          walletAddress: this.userData.walletAddress,
          walletAddressETH: this.userData.walletAddressETH,
          creditCard: this.userData.creditCard,
          paypal: this.userData.paypal,
        })

        Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Successfully',
        })

        this.$router.push('/dashboard')
      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
    getIMG(event) {
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.newAvatarImmage = files[0]

        // Auto refresh Avatar on page
        var self = this
        var reader = new FileReader()
        reader.onload = e => (self.userData.image = e.target.result)
        reader.readAsDataURL(files[0])
      }
    },
  },
  async created() {
    try {
      var response = await Api.myProfile()
      this.userData = response.data.results.user

      this.$nextTick(function() {

      })
    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/EditProfile/EditProfile.component.js